export const routes = (prefix = `theatre`) => [
    {
        path: `/${prefix}/theatre-queue`,
        name: `${prefix}.theatre-queue.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.theatre-queue.index`,
                PageDescription: "Theatre: Theatre Queue",
            },
        },
    },
];
